import React, { useContext, useCallback, useEffect } from 'react'
import { pushWithRegion } from 'actions/NavigationActions'
import AccountAccessModal from 'components/Account/AccountAccess/AccountAccessModal'
import type { AccountAccessModalResult } from 'components/Account/AccountAccess/AccountAccessModal.types'
import ModalContext from 'contexts/ModalContext'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import offerPageURL from 'lib/offer/offerPageURL'
import { selectLoggedIn } from 'selectors/accountSelectors'
import LuxPlusFreePreviewModal from '../modals/LuxPlusFreePreviewModal'
import LuxPlusHiddenOfferTransitionModal from './LuxPlusHiddenOfferTransitionModal'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { isFlashHotelOffer } from 'lib/offer/offerTypes'
import { fetchMemberFreePreviewEligibility } from 'actions/LuxPlusActions'

export default function useHiddenOfferClickHandler(offer: App.Offer | App.OfferSummary) {
  const showModal = useContext(ModalContext)
  const dispatch = useAppDispatch()
  const isLoggedInUser = useAppSelector(selectLoggedIn)
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)

  useEffect(() => {
    if (isLoggedInUser) {
      dispatch(fetchMemberFreePreviewEligibility())
    }
  }, [dispatch, isLoggedInUser])
  const openLogin = useCallback(() => {
    return showModal<AccountAccessModalResult>(<AccountAccessModal />)
  }, [showModal])
  const onHandleHiddenOffer = useCallback(async() => {
    if (isLoggedInUser) {
      if (!canViewLuxPlusBenefits) {
        showModal(<LuxPlusFreePreviewModal />)
      } else {
        dispatch(pushWithRegion(offerPageURL(offer)))
      }
    } else {
      const result = await openLogin()
      if (result.loggedIn) {
        showModal(<LuxPlusHiddenOfferTransitionModal offer={offer} />)
      }
    }
  }, [dispatch, canViewLuxPlusBenefits, isLoggedInUser, offer, openLogin, showModal])

  if (!isFlashHotelOffer(offer)) {
    return
  }

  return onHandleHiddenOffer
}
